export default __webpack_public_path__ + "static/media/google-button.8dd90d76.png";